import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import store from "./redux/store";
import { Provider } from "react-redux";

import { sendMessage, wsMsgType } from "./helpers/websocketHelper";

import { Layout2, LayoutPriceBoard } from "./components/_Layout";

import Statistic from "./components/Statistic";
import Login from "./components/Login";
import PromoPopup from "./components/PopUpAds";
import { AuthConfig, TVSIPriceBoardHasAuth } from "./helpers/constData";
import IpServerInfo from "./components/IpServerInfo";

class App extends Component {
   static displayName = App.name;

   constructor(props) {
      super(props);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
   }

   handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
         store.dispatch({ type: "TabIsFocus", payload: false });
      } else {
         store.dispatch({ type: "TabIsFocus", payload: true });
      }
   }

   componentDidMount() {
      document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
   }

   render() {
      return (
         <Provider store={store}>
            <BrowserRouter>
               <Switch>
                  {/* <Route
              exact
              path="/thongke"
              render={(routeProps) => {
                return (
                  <Layout2>
                    <Statistic {...routeProps} />
                  </Layout2>
                );
              }}
            /> */}
                  <Route exact path="/ip" render={(routeProps) => <IpServerInfo {...routeProps} />} />
                  <Route>
                     {/* 25/02 ẩn tạm popup */}
                     {/* {TVSIPriceBoardHasAuth === AuthConfig.No && (<PromoPopup/>)}         */}
                     <LayoutPriceBoard />
                  </Route>
               </Switch>
            </BrowserRouter>
         </Provider>
      );
   }
}

export default App;
